export default __webpack_public_path__ + "static/media/11.6ae9cb20.jpeg";